import axiosInstance from "axiosConfig";

export interface InvestmentSearchResult {
  uuid: string;
  name: string | null;
  origin: "reliance" | "other";
  currencyUuid: string | null;
  quantity: number | null;
  primaryValue: number;
  purchaseRate: number | null;
  status: string;
  slug: string | null;
}

const searchInvestmentsFetcher = async function searchInvestmentsFetcher(
  q: string,
  slug?: string
): Promise<InvestmentSearchResult[]> {
  const query = (q || "").trim();
  const res = await axiosInstance.get(`/investments/search`, {
    params: {
      q: query,
      slug,
    },
  });
  return res.data as InvestmentSearchResult[];
};

export default searchInvestmentsFetcher;
